<template>
  <div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="80vw" top="20px" @close="close">
      <el-form ref="form" v-if="dialogFormVisible" :model="form" label-width="80px">
        <el-form-item label="所属用户" prop="uid">
          <el-select v-model="form.uid" filterable remote reserve-keyword placeholder="请输入关键词"
            :remote-method="remoteMethod" @change="search_order">
            <el-option v-for="item in options" :key="item.id" :label="`${item.nickname} （${
                item.kor_code ? item.kor_code : '-'
              }）`" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户订单">
          <el-table ref="multipleTable" :data="tableData" border height="50vh" tooltip-effect="dark" style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="user_code" label="用户编号" width="100"></el-table-column>
            <!-- 商品图片 -->
            <el-table-column align="center" label="包裹图片" width="120">
              <template #default="{ row }">
                <el-image style="width: 60px; height: 60px" :src="row.pic" @click="see_img(row.pic)"
                  fit="contain"></el-image>
              </template>
            </el-table-column>
            <!-- 订单编号 -->
            <el-table-column show-overflow-tooltip prop="code" label="订单编号" width="350"></el-table-column>
            <!-- 运单号 -->
            <el-table-column show-overflow-tooltip prop="express_code" label="运单编号" width="230"></el-table-column>
            <!-- 国内单号 -->
            <el-table-column show-overflow-tooltip prop="old_code" label="国内单号" width="230"></el-table-column>
            <!-- 包裹状态 -->
            <el-table-column label="状态" align="center">
              <template #default="{ row }">
                <el-tag v-if="row.status == 0" size="small" type="danger">
                  未入库
                </el-tag>
                <el-tag v-if="row.status == 1" size="small" type="success">
                  已入库
                </el-tag>
                <el-tag v-if="row.status == 2" size="small" class="dabaoStyle">
                  待发货
                </el-tag>
                <el-tag v-if="row.status == 3" size="small" type="warning">
                  待支付
                </el-tag>
                <el-tag v-if="row.status == 4" size="small" class="fahuoStyle">
                  已出库
                </el-tag>
                <el-tag v-if="row.status == 5" size="small" type="primary">
                  已查验
                </el-tag>
                <el-tag v-if="row.status == 10" size="small" type="info">
                  已签收
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column label="发货方式" align="center">
              <template #default="{ row }">
                <div v-if="row.transport_type == 1" id="">CJ海运</div>
                <div v-if="row.transport_type == 2">CJ空运</div>
                <div v-if="row.transport_type == 3" id="">EMS海运</div>
                <div v-if="row.transport_type == 4" id="">EMS空运</div>
              </template>
            </el-table-column>
            <!-- 订单金额 -->
            <el-table-column show-overflow-tooltip prop="price" label="订单金额"></el-table-column>
            <!-- 收件人 -->
            <el-table-column show-overflow-tooltip prop="name" label="收件人" width="120" align="center"></el-table-column>
            <!-- 手机号 -->
            <el-table-column show-overflow-tooltip prop="phone" label="手机号" width="130"
              align="center"></el-table-column>

            <el-table-column show-overflow-tooltip label="创建时间" prop="add_time" width="170" align="center"
              sortable></el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="选择国家" prop="uid">
          <el-radio-group @input="country_change" v-model="form.countryId">
            <el-radio v-for="(item,index) in countryList" :key="index" :label="item.id">
              {{item.name}}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发货方式" prop="uid">
          <el-radio-group v-model="form.typeId">
            <el-radio v-for="(item,index) in typeList" :key="index" :label="item.id">
              {{item.text}}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="用户地址" prop="uid">
          <div style="display: flex; flex-direction: column;">
            <div style="margin-bottom: 8px;">
              <el-button type="primary" @click="open_new_address">新增地址</el-button>
            </div>
            <el-radio-group @input="radioInput" v-model="form.addressId">
              <div style="display: flex; flex-direction: column;">
                <el-radio v-for="(item,index) in AddressList" :key="index" :label="item.id"
                  style="margin-bottom: 16px; display: flex ; align-items: center;">
                  <div>
                    {{`${item.name}-${item.phone}-${item.address}`}}<br />
                    {{`身份证号:${item.idcode}`}}
                  </div>
                </el-radio>
              </div>
            </el-radio-group>
          </div>

        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submit">立即创建</el-button>
          <el-button @click="close">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="图片查看" :visible.sync="img_show" width="60vw" @close="imgclose">
      <el-image style="width: 100%;" :src="img_pic" @click="" fit="contain"></el-image>
    </el-dialog>
    <el-dialog title="新增地址" :visible.sync="new_address" width="60vw" @close="new_address_close">
        <el-form ref="address_form_ref" v-if="dialogFormVisible" :rules="address_roule" :model="new_address_form" label-width="80px">
          <el-form-item label="所属用户" prop="uid">
            <el-select :remote-method="remoteMethod"  v-model="new_address_form.uid" filterable remote reserve-keyword placeholder="请输入关键词">
              <el-option v-for="item in options" :key="item.id" :label="`${item.nickname} （${
                  item.kor_code ? item.kor_code : '-'
                }）`" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收件人" prop="name">
            <el-input v-model="new_address_form.name" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="new_address_form.phone" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="韩国省" prop="province">
            <el-input v-model="new_address_form.province" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="韩国市" prop="city">
            <el-input v-model="new_address_form.city" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="韩国区" prop="area">
            <el-input v-model="new_address_form.area" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="详细地址" prop="address">
            <el-input v-model="new_address_form.address" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="邮编" prop="zip_code">
            <el-input v-model="new_address_form.zip_code" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="身份证号" prop="idcode">
            <el-input v-model="new_address_form.idcode" placeholder="请输入" clearable />
          </el-form-item>
          <el-form-item label="通关方式" prop="clearance_type">
              <el-radio-group  v-model="new_address_form.clearance_type">
                <div style="display: flex; flex-direction: column;">
                  <el-radio v-for="(item,index) in type_list" :key="index" :label="item.type"
                    style="margin-bottom: 16px; display: flex ; align-items: center;">
                    <div>
                      {{item.text}}
                    </div>
                  </el-radio>
                </div>

              </el-radio-group>
          </el-form-item>
          <el-form-item v-if="new_address_form.clearance_type==1 || new_address_form.clearance_type==2" label="通关码" prop="clearance_code">
            <el-input v-model="new_address_form.clearance_code" placeholder="请输入" clearable />
          </el-form-item>


          <el-form-item>
            <el-button type="primary" @click="add_new_address('address_form_ref')">立即创建</el-button>
            <el-button @click="close">取消</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import {
    Order_user_order,
    memberListAllZdh,
    User_address_list,
    Index_get_country,
    Index_get_pic,
    Order_combined_box,
    update_user_address,
    Index_checkCode
  } from '@/api/xgcApi'
  import {
    getUploadUrl
  } from '@/config'
  import uploadFile from '@/components/uploadFile'
  export default {
    name: 'UserManagementEdit',
    components: {
      uploadFile,
    },
    data() {
      return {
        new_address_form: {
          "uid": null,
          "name": null,
          "phone": null,
          "province": null,
          "city": null,
          "area": null,
          "address": null,
          "zip_code": null,
          "idcode": null,
          "clearance_type": null,
          "clearance_code": null
        },
        address_roule:{
           uid: [{ required: true, message: '请选择用户', trigger: 'blur' }],
           name: [{ required: true, message: '请输入收货人', trigger: 'blur' }],
           phone: [{ required: true, message: '请输入收货人电话', trigger: 'blur' }],
           province: [{ required: true, message: '请输入韩国省/州', trigger: 'blur' }],
           city: [{ required: true, message: '请输入韩国城市', trigger: 'blur' }],
           area: [{ required: true, message: '请输入韩国区', trigger: 'blur' }],
           address: [{ required: true, message: '请输入韩国详细地址', trigger: 'blur' }],
           zip_code: [{ required: true, message: '请输入邮编', trigger: 'blur' }],
           idcode: [{ required: true, message: '身份证号', trigger: 'blur' }],
           clearance_type: [{ required: true, message: '请选择通关方式', trigger: 'blur' }],
           clearance_code: [{ required: true, message: '请输入通关码', trigger: 'blur' }],
        },
        type_list:[ //通关方式
        	{text:'个人通关码' , type:1},
        	{text:'韩国登陆证(韩国籍可使用身份证通关)' , type:2},
        	{text:'EMS通关' , type:4},
        ],
        title: '合箱',
        new_address: false,
        dialogFormVisible: false,
        chooseId: '', //选中的订单ID
        img_show: false,
        AddressList: [],
        typeList: [], //发货方式列表
        addressInfo: {},
        img_pic: '',
        form: {
          uid: '',
          addressId: '',
          countryId: null,
          typeId: ''
        },
        tableData: [],
        options: [],
        countryList: [],

      }
    },
    mounted() {
      // this.doConnect()
      this.getoptionList()
      this.getCountry()
    },
    methods: {
      open_new_address() {
        this.new_address = true
      },
      add_new_address(formName) {
         this.$refs[formName].validate((valid) => {
            if (valid) {
              if(this.new_address_form.clearance_type == 1){
                // 个人通关码需要验证
                var data = {
                  "idcode": this.new_address_form.clearance_code,  //通关码
                  "name": this.new_address_form.name, //姓名
                  "phone":this.new_address_form.phone //电话
                }
                Index_checkCode(data).then(res=>{
                  this.submit_address()
                })
              }else{
                // 非个人通关码不许呀验证
                this.submit_address()
              }
            } else {
              console.log('error submit!!');
              return false;
            }
          });

      },
      submit_address(data){
        update_user_address(this.new_address_form).then(res=>{
          this.$message({
            type:'success',
            message:'添加成功'
          })
          this.new_address_close()
          this.getAddressList(this.new_address_form.uid)
        })
      },
      new_address_close() {
        this.new_address = false
      },


      country_change(e) {
        this.getTypeList(e)
      },
      getCountry() {
        Index_get_country({}).then(res => {
          this.countryList = res.data
        })
      },
      getTypeList(id) {
        var data = {
          country_id: id
        }
        Index_get_pic(data).then(res => {
          this.typeList = res.data
        })
      },
      submit() {
        var data = {
          "order_id": this.chooseId,
          "uid": this.form.uid, //用户id
          "shipping_type": 4,
          "address": this.addressInfo.address,
          "province": this.addressInfo.province,
          "city": this.addressInfo.city,
          "area": this.addressInfo.area,
          "idcode": this.addressInfo.idcode,
          "zip_code": this.addressInfo.code,
          "name": this.addressInfo.name, //用户名
          "phone": this.addressInfo.phone, //电话号码
          "clearance_type": this.form.typeId
        }

        if (!this.form.uid) {
          this.$message({
            type: 'info',
            message: "请选择用户"
          })
          return
        }
        if (!this.form.addressId) {
          this.$message({
            type: 'info',
            message: "请选择地址"
          })
          return
        }
        if (!this.form.countryId) {
          this.$message({
            type: 'info',
            message: "请选择国家"
          })
          return
        }
        if (!data.clearance_type) {
          this.$message({
            type: 'info',
            message: "请选择发货方式"
          })
          return
        }
        if (this.chooseId == '') {
          this.$message({
            type: 'info',
            message: "请选择订单"
          })
          return
        }
        Order_combined_box(data).then(res => {
          this.$message({
            type: 'success',
            message: "操作成功"
          })
          // this.dialogFormVisible = false
          this.$emit('submit')
          this.close()
        })
      },
      close() {
        this.form = {
          uid: '',
          addressId: '',
          countryId: null,
          typeId: ''
        }
        this.tableData = []
        this.dialogFormVisible = false
      },
      see_img(url) {
        this.img_pic = url
        this.img_show = true
      },
      open() {
        this.dialogFormVisible = true
      },
      imgclose() {
        this.img_show = false
      },
      // 用户筛选
      remoteMethod(e) {
        this.page = 1
        this.limit = 20
        var data = {
          nickname: e,
          page: 1,
          limit: 100,
        }
        memberListAllZdh(data).then(({
          data
        }) => {
          this.options = data

        })
      },
      getAddressList(uid) {
        var data = {
          id: uid
        }
        User_address_list(data).then(res => {
          console.log(res, '用户地址信息')
          this.AddressList = res.data
        })
      },
      getoptionList() {
        var data = {
          page: 1,
          limit: 100,
        }
        memberListAllZdh(data).then(({
          data
        }) => {
          this.options = data
        })
      },
      radioInput(e) {

        var address = {}
        this.AddressList.map((item, index) => {
          if (item.id == e) {
            address = item
          }
        })
        this.addressInfo = address
      },
      handleSelectionChange(e) {
        var arr = []
        e.map((item, index) => {
          arr.push(item.id)
        })
        this.chooseId = arr.join(',')
      },
      search_order(e) {
        let data = {
          uid: e
        }
        Order_user_order(data).then(res => {
          this.tableData = res.data
          this.getAddressList(e)
        })
      }
    },
  }
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
